import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import "./setupTalGel";
import GelThemes from "./gelThemes";
import { ThemeContextProvider } from "./authentication/themes.context";
import { HelmetProvider } from "react-helmet-async";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

const IndexPage = () => {
  return (
    <React.StrictMode>
      <ThemeContextProvider>
        <GelThemes />
      </ThemeContextProvider>
    </React.StrictMode>
  );
};

root.render(
  <HelmetProvider>
    <IndexPage />
  </HelmetProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
